import {Component, OnInit} from '@angular/core';
import {BaseRendererComponent} from "../base-renderer/base-renderer.component";
import {ViewModelType} from "../../../models/type/view-model-type.enum";

@Component({
  selector: 'sb-checkbox-renderer',
  templateUrl: './checkbox-renderer.component.html',
  styleUrls: ['./checkbox-renderer.component.scss']
})
export class CheckboxRendererComponent extends BaseRendererComponent implements OnInit {

  constructor() {
    super();
  }

  ngOnInit(): void {
  }

  label() {
    return this.viewModelType() === ViewModelType.DETAIL ? this.i18nKey() : "";
  }

  disabled() {
    return this.elementOrViewModeReadOnly();
  }

  checked() {
    return this.fieldValue() === true;
  }

}
